import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["children", "href", "onClick", "showAsButton", "target", "params", "onPush", "onUpdateParams", "isAppRoute"];
import PropTypes from 'prop-types';
import isEmpty from 'transmute/isEmpty';
import { Button } from 'foundations-components/transitional/components/Button';
import { Link } from 'foundations-components/transitional/components/Link';
import { jsx as _jsx } from "react/jsx-runtime";
const AppLink = _ref => {
  let {
      children,
      href,
      onClick,
      showAsButton,
      target,
      params,
      onPush = () => {},
      onUpdateParams = () => {},
      isAppRoute = () => false
    } = _ref,
    props = _objectWithoutPropertiesLoose(_ref, _excluded);
  const handleClick = event => {
    // Don't handle cmd-clicks.
    const isNewWindowRequest =
    // Cmd-click.
    event.metaKey ||
    // Middle-mouse-button click.
    event.button === 1 ||
    // Anchor points to new window.
    target === '_blank';
    if (params && !isEmpty(params)) {
      onUpdateParams(params);
    }

    // Trigger `onClick` prop if given.
    if (onClick) onClick(event);

    // The `onClick` handler `preventDefault`ed. We shouldn't route.
    if (event.defaultPrevented) return;
    if (isNewWindowRequest) return;

    // Points outside of app. We don't want to handle it.
    if (!isAppRoute(href)) return;
    onPush(href);

    // Prevent the browser from handling the event and routing away.
    event.preventDefault();
  };
  const propsToPassDown = Object.assign({
    href,
    target
  }, params, props);
  const LinkComponent = showAsButton ? Button : Link;
  return /*#__PURE__*/_jsx(LinkComponent, Object.assign({
    "data-test-id": showAsButton ? 'button-component' : 'link-component'
  }, propsToPassDown, {
    onClick: handleClick,
    children: children
  }));
};
AppLink.propTypes = {
  children: PropTypes.node,
  href: PropTypes.string.isRequired,
  onClick: PropTypes.func,
  showAsButton: PropTypes.bool,
  target: PropTypes.string,
  params: PropTypes.object,
  onPush: PropTypes.func.isRequired,
  onUpdateParams: PropTypes.func.isRequired,
  isAppRoute: PropTypes.func.isRequired
};
export default AppLink;